import { Form, Input } from "decorator-form";

import { ILayout } from "../../common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "../../core/components/FragmentLayout";
import { FragmentProvider } from "../../core/components/FragmentProvider";
import * as fragments from "./fragments";


const fragmentLayoutInput = FragmentProvider.getLayoutInput({...fragments});

@Form({title: "Page Info"})
export default class PageInfoConfig {

	@Input({type: fragmentLayoutInput, title: "Main Layout"})
	public mainLayout: ILayout<IFragmentLayoutConfig>;

}



// WEBPACK FOOTER //
// ./src/panels/pageInfo/PageInfoConfig.ts